import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const softwareReportsCumulativeRoute: InvariantJiraRoute = {
	name: 'software-reports-cumulative',
	path: '/jira/software/projects/:projectKey/boards/:boardId/reports/cumulative',
};
